import React from 'react';

import { Text } from '../text/Text';

export const CardLabelText: React.FC<{ children?: React.ReactNode }> = ({ children }) => {
  return (
    <Text size="sm" fontWeight="bold">
      {children}
    </Text>
  );
};
